import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { OverlayModule } from '@angular/cdk/overlay';

// import { HttpModule } from '@angular/http';

import { HighchartsChartModule } from 'highcharts-angular';

import { AppRoutingModule, routingComponents } from './app-routing.module';
import { AppComponent } from './app.component';
import { BasicAuthHttpInterceptorService } from './services/authentication/basic-auth-http-interceptor.service';
import { HeaderComponent } from './components/template/header/header.component';
import { FooterComponent } from './components/template/footer/footer.component';
import { SidebarComponent } from './components/template/sidebar/sidebar.component';
import { CheckboxModule } from 'primeng/checkbox';

import { ChartModule } from 'primeng/chart';
import { TableModule } from 'primeng/table';
import {TooltipModule} from 'primeng/tooltip';
import { DropdownModule } from 'primeng/dropdown';
import {DialogModule} from 'primeng/dialog';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import {MessagesModule} from 'primeng/messages';
import {TabViewModule } from 'primeng/tabview';
import { FileUploadModule  } from 'primeng/fileupload';
import {MultiSelectModule} from 'primeng/multiselect';
import {CalendarModule} from 'primeng/calendar';
// import { BrowserAnimationsModule } from 'primeng/utils/';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { FilterComponent } from './shared/components/filter/filter.component';
import { DatePipe } from '@angular/common';
import { HistoryComponent } from './components/pages/history/history.component';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { CloseOpportunityComponent } from './components/pages/opportunities/close-opportunity/close-opportunity.component';
import { InfoComponent } from './components/pages/info/info.component';
import { SelectButtonModule } from 'primeng/selectbutton';
import { FilterDialogComponent } from './shared/components/filter-dialog/filter-dialog.component';
import { SliderModule } from 'primeng/slider';
import { FilterTextDialogComponent } from './shared/components/filter-text-dialog/filter-text-dialog.component';
import { DropdownFilterComponent } from './shared/components/dropdown-filter/dropdown-filter.component';
import { UserProfileComponent } from './components/pages/user-profile/user-profile.component';
import { NO_ERRORS_SCHEMA, isDevMode } from '@angular/core';
import { TreeModule } from 'primeng/tree';
import { ProductInventoryComponent } from './components/pages/product-inventory/product-inventory.component';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { StocksComponent } from './components/pages/stocks/stocks.component';
import {ToastModule} from 'primeng/toast';
import {ContextMenuModule} from 'primeng/contextmenu';
import {ProgressBarModule} from 'primeng/progressbar';
import {ToolbarModule} from 'primeng/toolbar';
import {RatingModule} from 'primeng/rating';
import {RadioButtonModule} from 'primeng/radiobutton';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ProductsListsComponent } from './shared/components/products-lists/products-lists.component';
import { OrderComponent } from './components/pages/order/order.component';
import { TreeTableModule } from 'primeng/treetable';
import { PickListModule } from 'primeng/picklist';
import { ProductModuleComponent } from './components/pages/Product-Module/productModule.component';
import { CustomerOrdersComponent } from './components/pages/customer-orders/customer-orders.component';
import { OrderItemDetailsComponent } from './components/pages/order-item-details/order-item-details.component';
import { AccordionModule } from 'primeng/accordion';
import { PdfConverterComponent } from './components/pages/pdf-converter/pdf-converter.component';
import { SplitButtonModule } from 'primeng/splitbutton';
import { RfpComponent } from './components/pages/rfp/rfp.component';
import { ProspectsComponent } from './components/pages/prospects/prospects.component';
import { RfpFormComponent } from './components/pages/rfp-form/rfp-form.component';
import { ProspectFormComponent } from './components/pages/prospect-form/prospect-form.component';
import { TimelineModule } from 'primeng/timeline';
import { ChipsModule } from 'primeng/chips';
import { RfpDashboardComponent } from './rfp-dashboard/rfp-dashboard.component';
import { ProspectDashboardComponent } from './prospect-dashboard/prospect-dashboard.component';
import { StepsModule } from 'primeng/steps';

import { CardModule } from 'primeng/card';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { PasswordModule } from 'primeng/password';
import { ChipModule } from 'primeng/chip';
import { ProspectActivitySummaryComponent } from './prospect-activity-summary/prospect-activity-summary.component';
import { AppProspectSummaryComponent } from './app-prospect-summary/app-prospect-summary.component';
import { CustomerProspectSummaryComponent } from './customer-prospect-summary/customer-prospect-summary.component';
import { ProductTreeSelectComponent } from './shared/components/product-tree-select/product-tree-select.component';
import { TreeSelectModule } from 'primeng/treeselect';
import { BrandProspectSummaryComponent } from './brand-prospect-summary/brand-prospect-summary.component'; 
import { ProspectSummaryCustomersComponent } from './prospect-summary-customers-chart/prospect-summary-customers.component';
import { ProspectSummarySectorsComponent } from './prospect-summary-sectors/prospect-summary-sectors.component';


@NgModule({
  schemas: [NO_ERRORS_SCHEMA , CUSTOM_ELEMENTS_SCHEMA],

  declarations: [
    AppComponent,
    routingComponents,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    PageNotFoundComponent,
    FilterComponent,
    HistoryComponent,
    CloseOpportunityComponent,
    InfoComponent,
    FilterDialogComponent,
    FilterTextDialogComponent,
    DropdownFilterComponent,

    // angular 16
    UserProfileComponent,
    ProductInventoryComponent,
    StocksComponent,
    ProductsListsComponent,
    OrderComponent,
    ProductModuleComponent ,
    CustomerOrdersComponent,
    OrderItemDetailsComponent ,
    PdfConverterComponent,
    RfpComponent,
    RfpFormComponent,
    ProspectsComponent,
    ProspectFormComponent,
    RfpDashboardComponent,
    ProspectDashboardComponent ,
    ProspectActivitySummaryComponent,
    ResetPasswordComponent , 
    AppProspectSummaryComponent, 
    CustomerProspectSummaryComponent,
    ProductTreeSelectComponent ,
    BrandProspectSummaryComponent,
    ProspectSummaryCustomersComponent,
    ProspectSummarySectorsComponent 
  ],
  imports: [
    ChartModule,
    CheckboxModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    OverlayModule,
    NgIdleKeepaliveModule.forRoot(),
    DropdownModule,
    // PrimeNG Modules
    ChartModule,
    TableModule,
    TooltipModule,
    TabViewModule,
    DialogModule,
    ConfirmDialogModule,
    OverlayPanelModule,
    FileUploadModule,
    MultiSelectModule,
    CalendarModule,
    MessagesModule,
    BrowserAnimationsModule,
    // HighchartsChartModule,
    SelectButtonModule,
    TreeModule,
    ButtonModule,
    InputTextModule,
    InputNumberModule,
    ContextMenuModule,
    ToastModule,
    ProgressBarModule,
    ToolbarModule,
    RatingModule,
    RadioButtonModule,
    InputTextareaModule,
    SliderModule,
    TreeTableModule,
    PickListModule,
    AccordionModule,
    SplitButtonModule,
    TimelineModule,
    ChipsModule ,
    StepsModule,
    CardModule ,
    PasswordModule ,
    ChipModule ,
    TreeSelectModule ,



],
  exports: [
    ProductsListsComponent
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS, useClass:BasicAuthHttpInterceptorService, multi:true
    },
    DatePipe,MessageService, ConfirmationService
  ],
  bootstrap: [AppComponent] ,

})
export class AppModule { }
